export const SELECTED_CHIP = 'SELECTED_CHIP';
export const SELECT_CHIP = 'SELECT_CHIP';
export const SELECT_CHIP_REMOVE_BTN = 'SELECT_CHIP_REMOVE_BTN';
export const SELECT_OPTION = 'SELECT_OPTION';
export const SELECT_CREATE_OPTION = 'SELECT_CREATE_OPTION';
